/**
 * A function to create a log object for the 'pageView' event (evid: 8301)
 *
 * Event description: Should be fired when a page is fully loaded (it is up to a consumer to decide when to consider a page as fully loaded)
 *
 * @param {pageViewParams} params - The parameters for this event
 * @property {string} flow - flow’s BI slug
 * @property {string} page - page’s BI slug
 * @return {LogObject<pageViewParams>} LogObject<pageViewParams>
 */
export function pageView(params) {
    return { evid: 8301, src: 2, endpoint: 'funnel-builder', params: params };
}
/**
 * A function to create a log object for the 'transitionStarted' event (evid: 8302)
 *
 * Event description: should be fired after the transition is initialized
 *
 * @param {transitionStartedParams} params - The parameters for this event
 * @property {string} destination - destination page’s BI slug, for internal transitions only
 * @property {string} direction - backward/forward
 * @property {string} flow - flow’s BI slug
 * @property {boolean} is_external - true, for external transitions only
 * @property {string} origin - previous page’s BI slug
 * @return {LogObject<transitionStartedParams>} LogObject<transitionStartedParams>
 */
export function transitionStarted(params) {
    return { evid: 8302, src: 2, endpoint: 'funnel-builder', params: params };
}
/**
 * A function to create a log object for the 'transitionFinished' event (evid: 8303)
 *
 * Event description: should be fired after the transition, that was started, is finished
 *
 * @param {transitionFinishedParams} params - The parameters for this event
 * @property {string} destination - destination page’s BI slug, for internal transitions only
 * @property {string} direction - forward/backward
 * @property {string} flow - flow’s BI slug
 * @property {boolean} is_external - true, for external transitions only
 * @property {string} origin - previous page’s BI slug
 * @return {LogObject<transitionFinishedParams>} LogObject<transitionFinishedParams>
 */
export function transitionFinished(params) {
    return { evid: 8303, src: 2, endpoint: 'funnel-builder', params: params };
}
//# sourceMappingURL=index.js.map